// extracted by mini-css-extract-plugin
module.exports = {"assumptions_container":"assumptionsSettings_assumptions_container__3kBzU","categories_form_container":"assumptionsSettings_categories_form_container__2fSjs"};